import { apiFetch } from '../../lib/api';

// The Reports talk to the server with POST only: ids and dates travel in the body, never in a URL. Nothing a report returns is kept anywhere: not in the
// browser's storage, not in the page cache (lib/dataCache.js treats /api/agent-reports/ as a read and does not remember it).

export const postReport = (path, body) => apiFetch(`/api/agent-reports/${path}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}) });

// The body of a request for a period: the pill, and the dates only for a custom period.
export const periodBody = (p) => (p.kind === 'custom' ? { period: 'custom', from: p.from, to: p.to } : { period: p.kind });

// A download (the commission statement, the Archive pack): POST, then the file is handed to the browser from memory. Returns true or false; the caller shows the message.
export async function downloadReport(path, body, fallbackName) {
  try {
    const res = await postReport(path, body);
    if (!res.ok) return false;
    const blob = await res.blob();
    const disposition = res.headers.get('content-disposition') || '';
    const name = (/filename="([^"]+)"/.exec(disposition) || [])[1] || fallbackName;
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = name; a.rel = 'noopener';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return true;
  } catch {
    return false;
  }
}

// The same download, but it says WHY it failed: { ok: true } or { ok: false, error: <the server's code, e.g. 'choose_shorter_period'> }.
export async function downloadReportWithReason(path, body, fallbackName) {
  try {
    const res = await postReport(path, body);
    if (!res.ok) {
      let code = null;
      try { code = (await res.json()).error; } catch { code = null; }
      return { ok: false, error: code };
    }
    const blob = await res.blob();
    const disposition = res.headers.get('content-disposition') || '';
    const name = (/filename="([^"]+)"/.exec(disposition) || [])[1] || fallbackName;
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = name; a.rel = 'noopener';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return { ok: true };
  } catch {
    return { ok: false, error: null };
  }
}

// The statement upload is the one multipart call: the file travels in the body (never in a URL) and is held by the server, not by the browser. The answer is { ok, id, ... } or { error: code }.
export async function uploadStatementFile(file) {
  const form = new FormData();
  form.append('file', file);
  const res = await apiFetch('/api/agent-reports/statement-upload', { method: 'POST', body: form });
  let json = null;
  try { json = await res.json(); } catch { json = null; }
  return res.ok && json && json.ok ? { ok: true, ...json } : { ok: false, error: (json && json.error) || 'generic' };
}
